import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { COMMUNITY_TYPE } from '../../../data/define';
import WriteModal from '../../../component/community/WirteModal';
import Analysis from '../../../component/community/write/Analysis';
import Growth from '../../../component/community/write/Growth';
import FreeBoard from '../../../component/community/write/FreeBoard';

function CommunityWritePage() {
  const [searchParams] = useSearchParams();
  const type = Number(searchParams.get('type'));
  const [writeModalOpen, setWriteModalOpen] = useState(false);

  return (
    <div className="w-full">
      <div className="w-full">
        {type === COMMUNITY_TYPE.ANALYSIS && (
          <Analysis type={type} setWriteModalOpen={setWriteModalOpen} />
        )}
        {type === COMMUNITY_TYPE.GROWTH && (
          <Growth type={type} setWriteModalOpen={setWriteModalOpen} />
        )}
        {type === COMMUNITY_TYPE.FREE_BOARD && (
          <FreeBoard type={type} setWriteModalOpen={setWriteModalOpen} />
        )}
      </div>
      <WriteModal
        open={writeModalOpen}
        onClose={() => setWriteModalOpen(false)}
      />
    </div>
  );
}

export default CommunityWritePage;
